import { gql } from '@apollo/client'

export default gql(`
    query getUploadUrl($files: [UploadMediaInput] $project: String) {
        getUploadUrl(
            input: $files
            project: $project
        )
        {
            key
            url
            uploadUrl
        }
    }
    `
)
